// @flow
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { OMNISEARCH_RESULT_TYPES } from '../Omnisearch';
import SingleTypeSearch from '../SingleTypeSearch';


const StudentSearch = connect(
  _state => ({
    searchResultType: OMNISEARCH_RESULT_TYPES.student,
  }),
  (dispatch, { onChange }) => ({
    onChange(result) {
      if (onChange) {
        return onChange(result);
      }

      return dispatch(push(`/dashboard/student/${result.id}`));
    },
  }),
)(SingleTypeSearch);


export default StudentSearch;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSearch/index.js